<template>
    <div class="h-screen w-full overflow-y-auto bg-slate-50 p-4">
        <NuxtPage />
    </div>
</template>

<script setup>
</script>
